import styles from './sent-request-popup.module.scss'

const SentRequestPopup = ({ text }) => {
    return <div className={styles.wrapper}>
        <div className={styles.container}>
            {text}
        </div>
    </div>
}

export default SentRequestPopup